const AciHwReleaseNoticeApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/release-notice/get`,
  POST: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/release-notice/create`,
  PUT: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/release-notice/update`,
  DELETE: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/release-notice/delete`,
  EXPORT: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/release-notice/download`,
  EXPORT_RN: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/release-notice/exportRN`,
};

export default AciHwReleaseNoticeApiUrls
